import React from 'react';

const ConsultationFields = ({ payers, skus, formData, handleChange, errors }) => {
  return (
    <React.Fragment>
      <table className="fields">
        <tbody>
          <tr>
            <th><label htmlFor="payer_id">Payer</label></th>
            <td>
              <select name="payer_id" value={formData.payer_id} onChange={handleChange}>
                {payers.map(payer => (
                  <option key={payer.payerId} value={payer.payerId}>{payer.payerNm}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <th><label htmlFor="sku_cd">SKU Code</label></th>
            <td>
              <select name="sku_cd" value={formData.sku_cd} onChange={handleChange}>
                {skus.map(sku => (
                  <option key={sku.skuCd} value={sku.skuCd}>{sku.skuNm}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <th><label htmlFor="comm_method_cd">Communication Method</label></th>
            <td>
              <select name="comm_method_cd" value={formData.comm_method_cd} onChange={handleChange}>
                <option value="VIDEO">VIDEO</option>
                <option value="PHONE">PHONE</option>
                <option value="KIOSK">KIOSK</option>
              </select>
            </td>
          </tr>
          <tr>
            <th><label htmlFor="age">Age of the patient</label></th>
            <td>
              <input type="number" name="age" value={formData.age} onChange={handleChange} />
              {errors.age && <span className="error">{errors.age}</span>}
            </td>
          </tr>
          <tr>
            <th><label htmlFor="visit_duration">Duration in minutes</label></th>
            <td>
              <input type="number" name="visit_duration" value={formData.visit_duration} onChange={handleChange} />
              {errors.visit_duration && <span className="error">{errors.visit_duration}</span>}
            </td>
          </tr>
          <tr>
            <th><label htmlFor="diagnosis_cd">Diagnosis Code</label></th>
            <td>
              <input type="text" name="diagnosis_cd" value={formData.diagnosis_cd} onChange={handleChange} />
            </td>
          </tr>
          <tr>
            <th><label htmlFor="has_rx">Has prescription</label></th>
            <td>
              <input
                type="checkbox"
                name="has_rx"
                checked={formData.has_rx}
                onChange={(e) => handleChange({ has_rx: e.target.checked })}
              />
            </td>
          </tr>
          <tr>
            <th><label htmlFor="recommended_non_td_service">Recommended Non-Teladoc Service</label></th>
            <td>
              <input
                type="checkbox"
                name="recommended_non_td_service"
                checked={formData.recommended_non_td_service}
                onChange={(e) => handleChange({ recommended_non_td_service: e.target.checked})}
              />
            </td>
          </tr>
          <tr>
            <th><label htmlFor="brand_cd">Brand Code</label></th>
            <td>
              <input type="text" name="brand_cd" value={formData.brand_cd} onChange={handleChange} />
            </td>
          </tr>
        </tbody>
      </table>

      <h4>Couples Therapy</h4>
      <table className="fields">
        <tbody>
          <tr>
            <th><label htmlFor="couples_therapy_member_present">Member present</label></th>
            <td>
              <input
                type="checkbox"
                name="couples_therapy_member_present"
                checked={formData.couples_therapy_member_present}
                onChange={(e) => handleChange({ couples_therapy_member_present: e.target.checked })}
              />
            </td>
          </tr>
          <tr>
            <th><label htmlFor="couples_therapy_partner_present">Partner present</label></th>
            <td>
              <input
                type="checkbox"
                name="couples_therapy_partner_present"
                checked={formData.couples_therapy_partner_present}
                onChange={(e) => handleChange({ couples_therapy_partner_present: e.target.checked })}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default ConsultationFields;
